export const REPORTING_ERROR_ADDRESS = 'UPLOAD_BULLETIN/REPORTING_ERROR_ADDRESS';
export const NEW_LISTING = 'UPLOAD_BULLETIN/NEW_LISTING';
export const CREATE_LISTING_AND_PAY_FOR_PLAN = 'UPLOAD_BULLETIN/CREATE_LISTING_AND_PAY_FOR_PLAN';
export const EDIT_LISTING = 'UPLOAD_BULLETIN/EDIT_LISTING';
export const EDIT_LISTING_STATUS = 'UPLOAD_BULLETIN/EDIT_LISTING_STATUS';
export const EDIT_LISTING_PROMOTE_STATUS = 'UPLOAD_BULLETIN/EDIT_LISTING_PROMOTE_STATUS';
export const VALIDATE_PHONE = 'UPLOAD_BULLETIN/VALIDATE_PHONE';
export const LOAD_PLANS_DATA = 'UPLOAD_BULLETIN/LOAD_PLANS_DATA';
export const LISTINGS_TABLE_INLINE_UPDATE_SUCCESS = 'UPLOAD_BULLETIN/LISTINGS_TABLE_INLINE_UPDATE_SUCCESS';
export const EDIT_LISTING_SILENT = 'UPLOAD_BULLETIN/EDIT_LISTING_SILENT';
export const EDIT_LISTING_ASSIGNED_AGENT = 'UPLOAD_BULLETIN/EDIT_LISTING_ASSIGNED_AGENT';
